export const environment = {
  production: false,
  apiUrl: "https://sabadell.4sfera.eu/api",
  documentUrl: "https://sabadell.4sfera.eu/assets/documents"
  /*apiUrl: "http://localhost:8080/api",
  documentUrl: "https://aire.ad/assets/documents"*/
};
